// 클럽 URL 없이 접속했을 때의 fallback 랜딩.
//
// `/c/<slug>/` 형태가 아니면 어떤 클럽인지 알 수 없으므로 안내 카드 + B2B
// 잠재 고객용 CTA + 문의 이메일을 표시. 자유 가입은 막혀있지만(B2B 모델),
// "우리 클럽도 시작하기" 신청 폼은 페어매치팀이 수동 처리하는 lead 캡처
// 채널이라 정책 충돌 없음. (project_auth_model / project_landing_and_directory_roadmap)

import { openClubSignupSheet } from "../auth/clubSignupSheet";
import { BRAND } from "../state";
import { mountPreact } from "../ui/preact-mount";

function NoClubLanding() {
  return (
    <div class="stack" style="gap:18px">
      <div class="error-card">
        <h2>클럽 URL이 필요합니다</h2>
        <p>접속하려는 클럽의 주소를 확인해 주세요.<br />예) /c/your-club/</p>
      </div>

      <div class="section section--panel">
        <p class="card__lead" style="margin:0 0 6px">운영 중인 테니스 클럽이세요?</p>
        <p class="muted small" style="margin:0 0 12px">
          페어매치는 회장·운영진을 위한 정기모임/대진/통계 운영 도구예요.
          신청하시면 페어매치팀이 1~2일 내 연락드릴게요.
        </p>
        <button
          type="button"
          class="btn btn--primary btn--block"
          onClick={() => openClubSignupSheet()}
        >
          + 우리 클럽도 시작하기
        </button>
      </div>

      <p class="muted small" style="text-align:center;margin:0">
        문의:{" "}
        <a
          href={`mailto:${BRAND.contactEmail}`}
          style="color:inherit;text-decoration:underline"
        >
          {BRAND.contactEmail}
        </a>
      </p>
    </div>
  );
}

export function renderNoClubLanding(): void {
  const view = document.getElementById("view");
  if (!view) return;
  view.innerHTML = "";
  view.append(mountPreact(<NoClubLanding />));
  const topbar = document.querySelector(".topbar__title");
  if (topbar) topbar.textContent = "페어매치";

  // 클럽 컨텍스트가 없는 상태이므로 설정/관리자 메뉴는 의미 없음 — 숨김.
  // (guest_event 라우트가 같은 처리를 하는 것과 동일 패턴)
  const menuBtn = document.querySelector(".topbar__btn--menu") as HTMLElement | null;
  if (menuBtn) menuBtn.hidden = true;
  const back = document.querySelector(".topbar__btn--back") as HTMLElement | null;
  if (back) back.hidden = true;
}
